import {Component, Fragment} from "react"
import {Link} from "react-router-dom"
import PropTypes from "prop-types"
import CardRow from "../../../../shared/components/Styled/Card/CardRow.jsx"
import CardCol from "../../../../shared/components/Styled/Card/CardCol.jsx"
import Tooltip from 'rc-tooltip'

import "./MenuItem.scss"

export const DEFAULT_TYPE = 'link'
export const CTA_TYPE = 'cta'

class MenuItem extends Component {
  static propTypes = {
    linkRoute: PropTypes.string,
    isCurrentRoute: PropTypes.bool,
    type: PropTypes.string,
    onClick: PropTypes.func,
    icon: PropTypes.string.isRequired,
    activeIcon: PropTypes.string.isRequired,
    alt: PropTypes.string.isRequired,
  }
  render() {
    const {
      linkRoute,
      isCurrentRoute,
      icon,
      activeIcon,
      alt,
      label,
      tooltip,
      className='',
      menuType= DEFAULT_TYPE,
      onClick
    } = this.props

    return (
      <CardRow className={className} direction="column" align="center">
        <CardCol>
          {tooltip
            ?
            <Fragment>
              {menuType === DEFAULT_TYPE &&
                  <Tooltip placement={"right"} overlay={tooltip}>
                    <Link to={linkRoute} className={`${isCurrentRoute ? 'active' : ''}`}>
                      <img src={isCurrentRoute ? activeIcon : icon} alt={alt}/>
                    </Link>
                  </Tooltip>
              }
              { menuType === CTA_TYPE &&
                <Tooltip placement={"right"} overlay={tooltip}>
                  <button type="button" onClick={onClick}>
                    <img src={icon} alt={alt}/>
                  </button>
                </Tooltip>
              }</Fragment>

            : (<Fragment>
              { menuType === DEFAULT_TYPE &&
                    <Link to={linkRoute} className={`${isCurrentRoute ? 'active' : ''}`}>
                      <img src={isCurrentRoute ? activeIcon : icon} alt={alt}/>
                    </Link>
              }
              { menuType === CTA_TYPE &&
                <button type="button" onClick={onClick}>
                  <img src={icon} alt={alt}/>
                </button>
              }
            </Fragment>
            )}
        </CardCol>
        <CardCol className="label-col" align="center">
          <span className="menu-item-label">{label}</span>
        </CardCol>
      </CardRow>
    )
  }
}

export default MenuItem